import React, {ReactElement, useCallback, useState} from 'react';

import {ExpertIcon} from '../../../resources/Icons';
import Col from '../../common/Col';
import AlertBox from './AlertBox';
import BalloonBox from './BalloonBox';
import NormalButton from './buttons/NormalButton';
import {ExpertButton} from './buttons/PillButtons';
import ModalButton from './ModalButton';
import PayExpertCard from './PayExpertCard';

type HelpExpertProps = {
  text: string;
  cost: number;
  canPay?: boolean;
  purchased: boolean;
  onPayClick: () => boolean;
};

const HelpExpert = (props: HelpExpertProps): ReactElement => {
  const {text, cost, canPay = true, purchased, onPayClick} = props;
  const [forceReset, setForceReset] = useState(0);

  const onAnswerClick = useCallback(() => {
    setForceReset(prevState => prevState + 1);
  }, []);

  const bottomButton = (
    <div className="flex justify-center">
      <NormalButton className="px-60 mobile:px-10 py-10" onClick={onAnswerClick}>
        Select an Answer
      </NormalButton>
    </div>
  );

  return (
    <ModalButton
      title="Talk to an expert"
      button={<ExpertButton className="mobile:!p-2" cost={cost} />}
      bottom={purchased && bottomButton}
      forceReset={forceReset}
    >
      {!purchased ? (
        <Col className="my-20 space-y-10 items-center text-center">
          <p className="font-semibold text-2xl mobile:text-xl">
            Talking to an expert will allow you to seek the best answer to your question
          </p>
          <PayExpertCard cost={cost} disabled={!canPay} onPayClick={onPayClick} />
          {!canPay && <AlertBox>You do not have enough money for this option</AlertBox>}
        </Col>
      ) : (
        <Col className="mt-20 mb-10 space-y-16 items-center text-center">
          <div className="w-52 h-52">
            <ExpertIcon />
          </div>
          <BalloonBox>{text}</BalloonBox>
        </Col>
      )}
    </ModalButton>
  );
};

export default HelpExpert;
